import { render, staticRenderFns } from "./dorucovaniLekuVoticeSummary.vue?vue&type=template&id=4f88f5a0&"
import script from "./dorucovaniLekuVoticeSummary.vue?vue&type=script&lang=js&"
export * from "./dorucovaniLekuVoticeSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports